import * as React from 'react';
import {Modal} from "../../Modal";
import Button from "../../Button";
import './EditProductLogoModal.css';
import { IProductLogo } from '../../../infrastructure/interfaces'
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import { contentImagesRelativePath } from '../../../constants';

export interface EditProductLogoProps {
    show: boolean;
    onClose: any;
    productLogo?: IProductLogo;
    updateProductLogo(formData: FormData): void;
}

export interface EditProductLogoState {
    //Form State
    logoPath: string;
    formData: FormData;
}

export default class EditProductLogoModal extends React.Component<EditProductLogoProps, EditProductLogoState> {

    constructor(props: any) {
        super(props);

        this.state = {
            logoPath: "",
            formData: new FormData()
        };
        this.onSave = this.onSave.bind(this);
    }

    updateProductLogo = () => {
        if (this.props.updateProductLogo) {
            this.props.updateProductLogo(this.state.formData);
        }
    }

    handleChange(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {

            for (var key in selectorFiles) {
                // check if this is a file. If so, add it and exit.
                if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
                    this.state.formData.set(ImageFileTypes.PRODUCT_LOGO, selectorFiles[key]);
                    break;
                }
            }
        }
    }

    onSave() {

        this.props.onClose();
        if (this.props.productLogo) {
            this.state.formData.set('id', this.props.productLogo.id);
        }
        this.updateProductLogo();
    }


    render() {

        return (
            <Modal show={this.props.show}
                   onClose={this.props.onClose}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5>
                            {this.props.productLogo ? this.props.productLogo.id : 'Upload Logo'}
                        </h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={this.props.onClose}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="productLogoContainer">
                        <div className="productLogoInputContainer">
                            <label>
                                Image (SVG)
                            </label>
                            <input type="file" className="filepond" onChange={(e) => this.handleChange(e.target.files)} />
                        </div>
                    {
                        (this.props.productLogo)
                        ? <div className="productLogoImageContainer"><img className="editImageModalImage" src={contentImagesRelativePath + this.props.productLogo.src} /></div>
                        : <div></div>
                    }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={this.props.onClose}>
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        disabled={false}
                        onClick={() => {
                            this.onSave();
                        }}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/EditProductLogoModal/EditProductLogoModal.tsx